import service from "@irati/utils/tracking/index"

const tracking: any = {}

tracking.clickRewardPointsWallet = (role: string) => {
  const data = {role}
  service.trackWalletEvent("wallet_navigate_reward_wallet", data)
}

tracking.browseRewardCatalogue = (role: string) => {
  const data = {role}
  service.trackWalletEvent("wallet_click_reward_catalogue", data)
}

tracking.walletSelectRegion = (regions: string[], role: string) => {
  const data = {regions, role}
  service.trackWalletEvent("wallet_click_select_region", data)
}

tracking.buyPoints = () => {
  service.trackWalletEvent("wallet_click_buy_points")
}

tracking.giveRewardPoints = (role: string) => {
  const data = {role}
  service.trackWalletEvent("wallet_click_give_points", data)
}

tracking.selectAssignBudget = () => {
  service.trackWalletEvent("wallet_click_assign_budget")
}

tracking.assignBudgetSuccess = () => {
  service.trackWalletEvent("reward_wallet_assign_budget_success")
}

tracking.assignBudgetError = (error: string) => {
  const data = {error}
  service.trackWalletEvent("reward_wallet_assign_budget_error", data)
}

tracking.selectRewardEmployees = (role: string) => {
  const data = {role}
  service.trackWalletEvent("wallet_click_reward_employees", data)
}

tracking.rewardEmployeesSuccess = () => {
  service.trackWalletEvent("reward_wallet_reward_employees_success")
}

tracking.rewardEmployeesError = (error: string) => {
  const data = {error}
  service.trackWalletEvent("reward_wallet_reward_employees_error", data)
}

tracking.payByCard = (role: string) => {
  const data = {role}
  service.trackWalletEvent("wallet_click_buy_points_card", data)
}

tracking.payByCardSuccess = () => {
  service.trackWalletEvent("wallet_click_buy_points_card_success")
}

tracking.payByCardError = (error: string) => {
  const data = {error}
  service.trackWalletEvent("wallet_click_buy_points_card_error", data)
}

tracking.bankTransfer = (role: string) => {
  const data = {role}
  service.trackWalletEvent("wallet_click_buy_points_bank", data)
}

tracking.bankTransferSuccess = () => {
  service.trackWalletEvent("wallet_click_buy_points_bank_success")
}

tracking.bankTransferError = (error: string) => {
  const data = {error}
  service.trackWalletEvent("wallet_click_buy_points_bank_error", data)
}

export default tracking
